import { ValueGetterParams } from "ag-grid-community";

export const numericColumnFilter = {
    filter: "agNumberColumnFilter",
    filterParams: {
        buttons: ["reset"]
    },
    filterValueGetter: filterValueGetter
};

function filterValueGetter(params: ValueGetterParams) {
    const value = params.getValue(params.colDef.field!);
    return typeof value === "string"
        ? value.length === 0
            ? undefined
            : Number.parseFloat(value.replace(/,/g, ""))
        : value;
}